module.exports = __webpack_public_path__ + "img/pc1.76032084.png";